<app-card-consulta
  (update)="update.emit($event)"
  [titulo]="titulo"
  [idConsulta]="idConsulta"
  [tipoConsulta]="tipoConsulta"
  [codigoControle]="codigoControle"
  [status]="status"
  [token]="token"
>
  <ng-container *ngIf="consulta">
    <ul class="card-list-striped">
      <li>
        <span class="text-secondary">Marca </span
        ><span>{{ consulta?.marcaModelo || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Código Marca/Modelo </span
        ><span>{{ consulta?.codMarcaModelo || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Placa </span
        ><span>{{ consulta?.placa || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Renavam </span
        ><span>{{ consulta?.renavam || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Documento </span
        ><span>{{ consulta?.numIdentProprietario || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">UF </span
        ><span>{{ uf || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Município </span
        ><span>{{ municipio || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Ano Fabricacao </span
        ><span>{{ consulta?.anoFabricacao || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Ano Modelo </span
        ><span>{{ consulta?.anoModelo || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Chassi </span
        ><span>{{ consulta?.chassi || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Cor </span
        ><span>{{ consulta?.nomeCor || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Protocolo </span
        ><span>{{ consulta?.protocolo || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Data Última Atualização </span
        ><span>{{
          (dataUltimaAtualizacao | date : "dd/MM/yyyy HH:mm:ss") ||
            "NÃO INFORMADO"
        }}</span>
      </li>

      <li>
        <span class="text-secondary">Situação </span
        ><span>{{ consulta?.tipoSituacaoVeiculo || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Proprietário </span
        ><span>{{ consulta?.nomeProprietario || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Documento Proprietário </span
        ><span>{{ consulta?.numIdentProprietario || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Tipo Documento Proprietário </span
        ><span>{{ consulta?.tipoDocProprietario || "NÃO INFORMADO" }}</span>
      </li>
    </ul>
  </ng-container>

  <ng-container *ngFor="let p of consulta?.listaCsvnacional; let i = index">
    <h2 class="subtitle">INSPEÇÃO</h2>
    <ul class="card-list-striped">
      <li>
        <span class="text-secondary">Chassi </span
        ><span>{{ p?.chassi || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Proprietário </span
        ><span>{{ p?.proprietario || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">ITL </span
        ><span>{{ p?.itl || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Documento ITL </span
        ><span>{{ p?.itlCnpj || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Data Inspeção </span
        ><span>{{ p?.dataInspecao || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Escopo </span
        ><span>{{ p?.escopo || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Local Inspeção </span
        ><span>{{ p?.municipio || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Tipo CSV </span
        ><span>{{ p?.tipoCsv || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Identificação CSV </span
        ><span>{{ p?.identificacaoCsv || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">URL CSV </span
        ><span style="font-weight: bold"
          ><a href="{{ p?.pdfPath }}" target="_blank">ACESSE AQUI</a></span
        >
      </li>
    </ul>
  </ng-container>
</app-card-consulta>

<ng-container *ngIf="inspecaoCsvSemDados">
  <app-card-consulta
    [titulo]="statusMsg"
    [status]="status"
    [msg]="texto"
  ></app-card-consulta>
</ng-container>
